import script from "./TileBase.vue?vue&type=script&setup=true&lang=ts"
export * from "./TileBase.vue?vue&type=script&setup=true&lang=ts"

import "./TileBase.vue?vue&type=style&index=0&id=2e538a51&lang=scss&scoped=true"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e538a51"]])

export default __exports__